<template>
  <div class="bb-set-manager">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <label class="bb-set-manager-search">
      <input class="bb-set-manager-search__input bb-input bb-input_search"
             type="text"
             @input="inputSearch"
             placeholder="Username">
      <i class="icon-search bb-set-manager-search__icon"/>
    </label>
    <div class="bb-set-manager-selected">
      <span class="bb-set-manager-selected__title">{{managerType}}</span>
     <transition name="fade-from">
       <div class="bb-set-manager-selected__user" v-if="selectedUser.id">
         <img class="bb-set-manager-list-item__photo bb-set-manager-list-item__photo_active"
              :src="getImage(selectedUser)">
         <span class="bb-set-manager-list-item__username bb-set-manager-list-item__username_active">
           {{selectedUser.username}}
         </span>
       </div>
     </transition>
    </div>
    <VuePerfectScrollbar class="bb-set-manager-list">
      <div class="bb-set-manager-list-item" v-for="user in usersList" :key="user.id" @click="selectedUser = user">
        <img class="bb-set-manager-list-item__photo"
             :class="{'bb-set-manager-list-item__photo_active': selectedUser.id === user.id}"
             :src="getImage(user)">
        <span class="bb-set-manager-list-item__username"
              :class="{'bb-set-manager-list-item__username_active': selectedUser.id === user.id}">
          {{user.username}}
        </span>
        <transition name="bounce">
          <i class="icon-check bb-set-manager-list-item__checked" v-if="selectedUser.id === user.id"/>
        </transition>
      </div>
    </VuePerfectScrollbar>
    <div class="bb-set-manager-footer">
      <button class="bb-button bb-button_border bb-button_border_gray" @click="closeForm">CANCEL</button>
      <button class="bb-button" @click="saveForm">SAVE</button>
    </div>
  </div>
</template>

<script>
import UsersListApi from '@/api/UsersList/api'
import {filter, trim, debounce, groupBy, orderBy, get} from 'lodash'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import defaultAvatar from '@/assets/images/user.png'

export default {
  name: 'SetManager',
  props: ['project', 'type'],
  components: {
    LoaderFly,
    VuePerfectScrollbar
  },
  data () {
    return {
      defaultAvatar: defaultAvatar,
      selectedUser: {},
      loaderRun: false,
      searchWords: '',
      usersList: []
    }
  },
  computed: {
    managerType () {
      return this.type === 'pm' ? 'Project Manager' : 'Business Consultant'
    },
    getWithSearch () {
      return debounce(this.getUserList, 250)
    }
  },
  methods: {
    getImage (user) {
      const imagePath = get(user, 'image.path', '')
      const image = get(user, 'image', defaultAvatar)
      return imagePath || image
    },
    setCurrentUser () {
      const manager = get(this.project, 'serviceProjectManager', {})
      const consultant = get(this.project, 'businessConsultant', {})
      this.selectedUser = this.type === 'pm' ? manager : consultant
    },
    closeForm () {
      this.$emit('close')
    },
    saveForm () {
      this.$emit('save', {type: this.type, user: this.selectedUser})
    },
    inputSearch (e) {
      const val = e.target.value
      const searchValue = trim(val.toLowerCase())
      this.searchWords = 'search=' + searchValue || ''
      this.getUserList({})
    },
    getUserList ({limit, page}) {
      this.loaderRun = true
      UsersListApi.getUsersList({limit, page, assigned: true, filter: this.searchWords})
        .then((resp) => {
          this.loaderRun = false
          this.usersList = this.getUsersByDepartment(resp.data.users)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getUsersByDepartment (usersList) {
      const type = this.type === 'pm' ? 2 : 1
      const users = filter(usersList, user => {
        const department = get(user, 'position.department', '')
        return department === type
      })
      const groupUsers = groupBy(users, 'isNotAssigned')
      const isNotAssigned = groupUsers.true || []
      const sortedUsers = orderBy(groupUsers.false, [item => item.firstName.toLowerCase()], ['asc'])
      return [...sortedUsers, ...isNotAssigned]
    }
  },
  beforeMount () {
    this.setCurrentUser()
    this.getUserList({})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-set-manager {
    @include global-font;
    min-width: 577px;
    max-height: 640px;

    &-search {
      position: relative;
      display: flex;
      align-items: center;
      background: $color-white;
      border: 1px solid $color-mercury;
      box-sizing: border-box;
      border-radius: 6px;
      margin: 8px 22px 17px;

      &__input {
        width: 100%;
      }

      &__icon {
        position: absolute;
        left: 13px;
        font-size: 15px;
        color: $color-silver;
      }
    }

    &-selected {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 22px;
      min-height: 28px;
      margin-bottom: 19px;

      &__title {
        margin-right: 16px;
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
      }

      &__user {
        display: grid;
        grid-template-columns: 32px 1fr 16px;
        grid-gap: 9px;
        align-items: center;
      }
    }

    &-list {
      padding: 0 22px;
      max-height: 200px;

      &-item {
        display: grid;
        grid-template-columns: 32px 1fr 16px;
        grid-gap: 9px;
        align-items: center;
        justify-content: center;
        padding: 10px 0;
        border-bottom: 1px solid $color-wild-sand;
        cursor: pointer;

        &:hover &__username {
          color: $color-accent;
        }

        &__photo {
          border: 2px solid transparent;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          transition: 0.3s;

          &_active {
            border-color: $color-accent;
          }
        }

        &__username {
          text-transform: capitalize;
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;
          color: $color-black;
          transition: 0.3s;

          &_active {
            color: $color-accent;
          }
        }

        &__checked {
          color: $color-accent;
          font-size: 12px;

          &:before {
            margin: 0;
          }
        }
      }
    }

    &-footer {
      display: grid;
      grid-template-columns: 103px 103px;
      grid-gap: 12px;
      align-items: center;
      justify-content: end;
      padding: 19px;
      background: $color-wild-sand;
      border-radius: 0 0 8px 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactProjects/SetManager/SetManager.vue